export enum CustomerBrandingRequestAction {
  Approve = 1,
  Reject = 2,
  ApproveWithModification = 3,
  Revoke = 4,
}
